import type { UseCaseSlug } from "./types";

/**
 * URL of a use-case page. Kept apart from the registry so vertical configs
 * can link to each other without importing it (the registry imports them).
 */
export const hrefForUseCase = (slug: UseCaseSlug) => `/use-cases/${slug}/`;
